import { render } from "./SettingsNotifications.vue?vue&type=template&id=575e6ae0"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__